import React from 'react';
import Rectangle from '@splunk/dashboard-visualizations/Rectangle';

export default () => <Rectangle options={{ fill: '#00ffff', fillOpacity: 0.5 }} />;
